import React from 'react';
import PropTypes from 'prop-types';
import { Box, Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/InfoRounded';

const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
  },

  tooltip: {
    marginLeft: 4,
  },
};

TableStatus.propTypes = {
  status: PropTypes.string,
};

export function TableStatus({ status }) {
  const isFailed = /failed/i.test(status);
  const isDetailedFailure = status !== 'Failed';

  return (
    <Box sx={styles.root}>
      {!isFailed && status}
      {isFailed && 'Failed'}

      {isFailed && isDetailedFailure && (
        <Tooltip sx={styles.tooltip} title={status}>
          <InfoIcon style={{ width: '20px' }} />
        </Tooltip>
      )}
    </Box>
  );
}
